type ProcessEnvLike = {
  env?: Record<string, string | undefined>;
};

export function readIAiProcessEnv(key: string) {
  const processLike = (globalThis as { process?: ProcessEnvLike }).process;
  if (processLike?.env && typeof processLike.env[key] === "string") {
    const value = processLike.env[key]?.trim();
    if (value) {
      return value;
    }
  }
  return "";
}

export function readIAiCsvEnv(key: string) {
  return readIAiProcessEnv(key)
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);
}
